import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 50,
  },
  paper: {
    padding: theme.spacing(6),
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3),
    },
  },
  brand: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(4),
    margin: theme.spacing(4, 0),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  },
  realtorInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '1 1 0',
    minWidth: 0,
  },
  realtorName: {
    fontSize: 30,
    fontWeight: 600,
    lineHeight: 1.2,
    wordBreak: 'break-word',
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  realtorCompany: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
  logoDivider: {
    alignSelf: 'stretch',
    width: 2,
    minHeight: 120,
    borderRadius: 1,
    background: theme.palette.divider,
    [theme.breakpoints.down('xs')]: {
      alignSelf: 'center',
      width: '60%',
      minHeight: 0,
      height: 2,
    },
  },
  logoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flex: '1 1 0',
    minWidth: 0,
  },
  logo: {
    maxWidth: '100%',
    maxHeight: 200,
    objectFit: 'contain',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    '& > *': {
      minWidth: 160,
    },
  },
}));

export default useStyles;
